import store from '@/store';
import { computed, onMounted } from 'vue';
const useStreamdeck = () => {
    onMounted(async () => {
        const enable = localStorage.getItem("streamdeck-enabled");
        if (enable === 'true') {
            await store.dispatch.streamdeck.enable();
        }
    });
    return {
        enabled: computed(() => store.state.streamdeck.enabled),
        connected: computed(() => store.state.streamdeck.connected),
        enable: store.dispatch.streamdeck.enable,
        disable: store.dispatch.streamdeck.disable,
    };
};
export default useStreamdeck;
